import { first } from 'rxjs/operators';
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, OnInit } from '@angular/core';
import { AlertService } from '@app/_services';
import { LazyLoadEvent, MessageService, ConfirmationService } from 'primeng/api';
import { FileUpload } from '../file-upload';
import { FileUploadComponent } from '../file-upload/file-upload.component';
import { FileUploadService } from '../file-upload.service';

@Component({
    selector: 'app-file-upload-list',
    templateUrl: './file-upload-list.component.html',
    styleUrls: ['./file-upload-list.component.css'],
    providers: [MessageService, ConfirmationService, { provide: MAT_DIALOG_DATA, useValue: {} }],
    // make column heading sticky
    styles: [`
        :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
            position: -webkit-sticky;
            position: sticky;
            top: 0px;
        }

        @media screen and (max-width: 64em) {
            :host ::ng-deep .p-datatable .p-datatable-thead > tr > th {
                top: 99px;
            }
        }
`],
    standalone: false
})
export class FileUploadListComponent implements OnInit {
	constructor(
		private fileUploadService: FileUploadService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private dialog: MatDialog,
	) {
		this.statuses = fileUploadService.statuses
	}



	// data
	fileUploads: any;
	fileUpload: FileUpload;

	// paging
	first = 0;
	rows = 50;

	// list
	datasource: any;

	recordTotal: number;
	lazyLoadEvent: LazyLoadEvent;
	loading = true;
	multiSortMeta = [];

	// forms
	formLoading = false;

	statuses: any;

	columns: any[] = [
		{ field: 'fileUploadId', header: 'Id', width: 'auto' },
		{ field: 'name', header: 'Name', width: 'auto' },
		{ field: 'description', header: 'Description', width: 'auto' },
		{ field: 'fileName', header: 'File Name', width: 'auto' },
		{ field: 'taskId', header: 'Task Id', width: 'auto' },
	];

	ngOnInit(): void {
		try {
			// default sort of list
			this.multiSortMeta = [];
			this.multiSortMeta.push({ field: 'createDate', order: 0 });
		}
		catch (error) {
			console.log('Error: ' + error);
		}
	}

	/*********
	 * Delete Button
	 *
	 */
	onRowDelete(event: any) {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + event.fileUploadId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete(event);
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}


	/*********
	 * Lazy Load All Data
	 *
	 */
	loadLazy(event: LazyLoadEvent) {
		try {
			//this.loading = true;
			//this.lazyLoadEvent = event;

			console.log(
				' event.first:' + event.first
				+ '  |  event.rows:' + event.rows
				+ '  |  event.sortField:' + event.sortField
				+ '  |  event.sortOrder:' + event.sortOrder
				+ '  |  event.multiSortMeta:' + JSON.stringify(event.multiSortMeta)
				+ '  |  event.globalFilter:' + event.globalFilter
				+ '  |  event.filters:' + JSON.stringify(event.filters)
			);

			/*
			*
			* Default Sort
			*/
			// https://stackoverflow.com/questions/679915/how-do-i-fileUpload-for-an-empty-javascript-object
			// if we are NOT filtering and we are NOT sorting, apply a default sort
			if (Object.keys(event.filters).length === 0 && !event.multiSortMeta) {
				event.multiSortMeta = [];
				event.multiSortMeta.push({ field: 'createDate', order: -1 });
			}

			const pageNumber = Math.round(event.first / event.rows);
			this.fileUploadService.findByFilter(
				pageNumber, event.rows,
				event.sortField,
				event.sortOrder,
				event.multiSortMeta,
				event.globalFilter,
				event.filters).pipe(first()).subscribe(

					(res: any) => {
						this.datasource = res.data.reviews;
						this.recordTotal = res.page.recordTotal;
						this.fileUploads = res.data.fileUploads;
						console.log(JSON.stringify(res.page));
					},
					(err: any) => {
						console.log('reviews list error!: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.loading = false; }
				);

			if (this.datasource) {
				this.fileUploads = this.datasource.slice(event.first, (event.first + event.rows));
			}
		} catch (error) {
			console.log('loadLazy(' + event + ')' + error);
		}
	}

	getStatus() {
		return
	}

	/*********
	 * onRowSelect()
	 * Used to handle row click (to edit, link, etc)
	 */
	onRowSelect(event: any) {
		console.log('onRowSelect: ' + JSON.stringify(event));
		this.onOpenFormEdit(event.data);
	}

	// handled in rate-bucket-form
	formAdd() { }


	/*********
	 * formUpdate()
	 * Used for row editing
	 */
	formUpdate(fileUpload: FileUpload) {
		try {
			this.formLoading = true;
			this.fileUploadService.update(fileUpload)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Update SUCCESS: ' + JSON.stringify(res));
						this.fileUploads.map((fileUpload, i) => {
							if (fileUpload.fileUploadId === res.data.fileUpload.fileUploadId) {
								this.fileUploads[i] = res.data.fileUpload;
							}
						});
						// this.alertService.success(res, true);
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
					},
					(err: any) => {
						console.log('Rate-Bucket-Update FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: JSON.stringify(err), life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
	 * formDelete()
	 * Used for row editing
	 */
	formDelete(fileUpload: any) {
		try {
			// stop here if form is invalid
			console.log('Delete Submitted: ' + JSON.stringify(fileUpload));

			this.formLoading = true;
			this.fileUploadService.delete(fileUpload.fileUploadId)
				.subscribe(
					(res: any) => {
						console.log('Rate-Bucket-Delete SUCCESS: ' + JSON.stringify(res));
						this.fileUploads.splice(this.fileUploads.indexOf(fileUpload), 1);
						this.recordTotal = this.fileUploads.length;
						this.messageService.add({ severity: 'success', summary: 'Successful', detail: 'FileUpload ' + fileUpload.fileUploadId + ' Deleted', life: 3000 });
					},
					(err: any) => {
						console.log('Rate-Bucket-Delete  FAIL: ' + JSON.stringify(err));
						this.messageService.add({ severity: 'error', summary: 'Delete Failed', detail: 'FileUpload ' + fileUpload.fileUploadId + ' could not be deleted.  Be sure there are no assigned properties to this bucket.', life: 3000 });
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	/*********
		 * Add New Button
		 *
		 */
	onOpenFormAdd() {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			title: 'Add FileUpload'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FileUploadComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doAdd' in the element to handle adding
		dialogRef.componentInstance.doAdd.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.addFileUploadCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/*********
		* Edit Button
		*
		*/
	onOpenFormEdit(fileUpload: FileUpload) {

		const dialogConfig = new MatDialogConfig();

		// settings
		dialogConfig.disableClose = false;
		dialogConfig.autoFocus = true;
		dialogConfig.hasBackdrop = true;

		// pass data, ie rateBuicket: this.shortTermRentalId,
		dialogConfig.data = {
			fileUpload: fileUpload,
			title: 'Edit FileUpload'
		};

		// open the popup and get a reference to it called dialogRef
		const dialogRef = this.dialog.open(FileUploadComponent, dialogConfig);

		// to receive the added element, subscribe to the eventEmitter we created 'doUpdate' in the element to handle updating the list
		dialogRef.componentInstance.doUpdate.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.updateFileUploadCB(data);

				// close the dialogBox
				dialogRef.close();
			});

		dialogRef.componentInstance.doDelete.subscribe(
			data => {
				console.log('Dialog output:', data);

				// when we doAdd in the element, call this parent and update the list so it shows the added element to the database
				this.deleteFileUploadCB(data);

				// close the dialogBox
				dialogRef.close();
			});
	}


	/**
	   *
	   * Dialog from Form Callbacks
	   * To edit the list show add/edit/delete in real time from the popup form
	   *
	   */
	addFileUploadCB(fileUpload: FileUpload) {
		console.log('Adding FileUpload: ' + JSON.stringify(fileUpload));
		// if we don't have a fileUploads array yet...
		if (!this.fileUploads) {
			this.fileUploads = [];
		}
		// unshift adds to the front of the array (), push adds to the back
		this.fileUploads.unshift(fileUpload);

		// no idea what this is but it is required to update the array
		this.fileUploads = [...this.fileUploads];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FileUpload ' + fileUpload.fileUploadId + ' Added', life: 3000 });
	}

	updateFileUploadCB(fileUpload: FileUpload) {
		console.log('Updating FileUpload: ' + JSON.stringify(fileUpload));
		let itemIndex = this.fileUploads.findIndex((item: any) => item.fileUploadId === fileUpload.fileUploadId);
		this.fileUploads[itemIndex] = fileUpload;

		// no idea what this is but it is required to update the array
		this.fileUploads = [...this.fileUploads];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FileUpload ' + fileUpload.fileUploadId + ' Updated', life: 3000 });
	}

	deleteFileUploadCB(fileUpload: FileUpload) {
		console.log('Removing FileUpload: ' + fileUpload);
		this.fileUploads.splice(this.fileUploads.indexOf(fileUpload), 1);
		this.recordTotal = this.fileUploads.length;

		// no idea what this is but it is required to update the array
		this.fileUploads = [...this.fileUploads];

		this.messageService.add({ severity: 'success', summary: 'Success', detail: 'FileUpload ' + fileUpload.fileUploadId + ' Deleted', life: 3000 });
	}

	/**********
	 *
	 * PAGINATOR FUNCTIONS
	 */
	next() { this.first = this.first + this.rows; }
	prev() { this.first = this.first - this.rows; }
	reset() { this.first = 0; }
	isLastPage(): boolean { return this.fileUploads ? this.first === (this.fileUploads.length - this.rows) : true; }
	isFirstPage(): boolean { return this.fileUploads ? this.first === 0 : true; }

	get Statuses() {
		return this.statuses;
	}

	getStatusName(fileUpload: any) {
		if (fileUpload?.status) {
			const status = this.statuses.find((e: any) => e.value == fileUpload.status);
			return status.name;
		}
		else {
			return '';
		}
	}
	
	reloadPage() {
		window.location.reload();
	}
}
